import React from "react";
import { METHODOLOGY, IMAGES } from "../mock/mock";
import useReveal from "../hooks/useReveal";

export default function Methodology() {
  const [ref, visible] = useReveal();

  return (
    <section id="metodologie" className="theme-light section-pad border-t border-[var(--pl-line)] bg-[var(--pl-bg)] py-24 text-[var(--pl-text)] md:py-36">
      <div className="mb-20 grid grid-cols-1 gap-8 md:mb-28 lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-12">
          <h2 className="font-display font-medium whitespace-nowrap text-[clamp(1.7rem,6.2vw,4.25rem)] leading-[1.02] tracking-[-0.01em] text-[var(--pl-text)]">
            METODOLOGIE
          </h2>
          <p className="mt-8 max-w-2xl text-[16px] leading-relaxed text-[var(--pl-text-2)] md:text-[17px]">
            {METHODOLOGY.intro}
          </p>
        </div>
      </div>

      <div ref={ref} className={`grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-20 reveal ${visible ? "is-visible" : ""}`}>
        <div>
          {METHODOLOGY.steps.map((s, i) => (
            <div
              key={s.num}
              className={`grid grid-cols-[auto_1fr] gap-x-6 border-t border-[var(--pl-line)] py-9 md:gap-x-10 ${
                i === METHODOLOGY.steps.length - 1 ? "border-b" : ""
              }`}
            >
              <span className="pt-3 font-mono text-xs text-[var(--pl-text)]">{s.num}</span>
              <div>
                <h3 className="font-display font-medium uppercase text-[clamp(1.75rem,3.2vw,2.75rem)] leading-none tracking-[-0.01em] text-[var(--pl-text)]">
                  {s.title}
                </h3>
                <p className="mt-5 max-w-md text-[15px] leading-relaxed text-[var(--pl-muted-text)] md:text-[16px]">
                  {s.text}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="relative lg:h-full">
          <div className="overflow-hidden lg:sticky lg:top-28">
            <div className="relative aspect-[4/5] w-full overflow-hidden">
              <img
                src={IMAGES.methodology}
                alt="Arhitectură abstractă Planimex"
                className="h-full w-full object-cover grayscale contrast-[1.05] transition-transform duration-[1.2s] ease-out hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 ring-1 ring-inset ring-[var(--pl-overlay-ring)]" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
